export class Group<T, M> {
  group: T
  constructor(instance: T) {
    this.group = instance
  }
  members(): M[] {
    throw 'not implemented exception'
  }
  invitees(): M[] {
    throw 'not implemented exception'
  }
  getMemberId(item: M): string {
    throw 'not implemented exception'
  }
  removeMember(id: string) {
    let index = this.members().findIndex((v) => this.getMemberId(v) === id)
    this.members().splice(index)
  }
  hasMember(member: M) {
    return (
      this.members().findIndex(
        (v) => this.getMemberId(v) === this.getMemberId(member),
      ) !== -1
    )
  }
  isMember(member: string): boolean {
    return (
      this.members().findIndex((v) => this.getMemberId(v) === member) !== -1
    )
  }
  addMembers(members: M[]) {
    let limit = 10
    if (this.has('member')) {
      limit = this.get('member')
    }
    let currentCount = this.members().length
    let newmembers = members.filter((v) => {
      return !this.hasMember(v)
    })
    let left = limit - currentCount
    if (left > newmembers.length) {
      this.members().push(...newmembers)
    } else {
      for (let i = 0; i < left; i++) {
        this.members().push(newmembers[i])
      }
    }
  }
  writers(): string[] {
    throw 'not implemented'
  }
  addToWriteGroup(id: string) {
    if (this.isMember(id)) {
      let index = this.writers().indexOf(id)
      if (index === -1) this.writers().push(id)
    }
  }
  promoteToAdmin(id: string) {
    if (this.isMember(id)) {
      let index = this.admins().indexOf(id)
      if (index === -1) this.admins().push(id)
    }
  }
  isAdmin(id: string) {
    return this.admins().indexOf(id) !== -1
  }

  demoteFromAdmin(id: string) {
    let index = this.admins().indexOf(id)
    if (index !== -1) this.admins().splice(index, 1)
  }
  admins(): string[] {
    throw 'not implemented'
  }
  readers(): string[] {
    throw 'not implemented'
  }
  addToReadGroup(id: string) {
    if (this.isMember(id))
      if (this.readers().indexOf(id) === -1) this.readers().push(id)
  }
  removeFromReadGroup(id: string) {
    let index = this.readers().indexOf(id)
    if (index !== -1) {
      this.readers().splice(index, 1)
    }
  }
  isInReadGroup(id: string): boolean {
    return this.readers().indexOf(id) !== -1
  }
  has(key: string): boolean {
    throw 'not implemented'
  }
  get(key: string): number {
    throw 'not implemented'
  }
  inviteMember(invitee: M) {
    let limit = 10
    if (this.has('invite')) {
      limit = this.get('invite')
    }
    if (this.invitees().length < limit) {
      let index = this.invitees().findIndex(
        (v) => this.getMemberId(v) === this.getMemberId(invitee),
      )
      if (index === -1) this.invitees().push(invitee)
    }
  }
  isInvited(id: string) {
    return this.invitees().some((v) => this.getMemberId(v) === id)
  }
  set(key: string, value: number) {
    throw 'not implemented'
  }
  setInviteLimit(limit: number) {
    this.set('invite', limit)
  }
  setMemberLimit(limit: number) {
    this.set('member', limit)
  }
  acceptInvitation(id: string) {
    let invitee = this.invitees().find((v) => this.getMemberId(v) === id)
    if (invitee) {
      this.addMembers([invitee])
    }
    this.deinviteMember(id)
  }
  membershipRequests(): M[] {
    throw 'not implemented'
  }
  requestMembership(requester: M) {
    let index = this.membershipRequests().findIndex(
      (r) => this.getMemberId(r) === this.getMemberId(requester),
    )
    if (index === -1) {
      this.membershipRequests().push(requester)
    }
  }
  withDrawMembership(id: string) {
    let index = this.members().findIndex((v) => this.getMemberId(v) === id)
    if (index !== -1) {
      this.members().splice(index, 1)
    }
  }
  rejectInvitation(id: string) {
    let inviteeIndex = this.invitees().findIndex(
      (v) => this.getMemberId(v) === id,
    )
    if (inviteeIndex !== -1) {
      this.invitees().splice(inviteeIndex, 1)
    }
  }
  deinviteMember(id: string) {
    let index = this.invitees().findIndex((v) => this.getMemberId(v) === id)
    if (index !== -1) {
      this.invitees().splice(index)
    }
  }
}
